import { graphql, rest } from 'msw';
import { MOCK_CLIENT_ID } from '../../../../mocks';

const stitchfix = graphql.link(
  process.env.NEXT_PUBLIC_GRAPHQL_API_ENDPOINT || '',
);

// Mock for getClientInfo query
export const getClientInfo = stitchfix.query(
  'getClientInfo',
  (_req, res, ctx) => {
    return res(
      ctx.data({
        client: {
          __typename: 'Client' as const,
          id: MOCK_CLIENT_ID,
          isAuthenticatedClient: true,
          capabilities: {
            __typename: 'ClientCapabilities' as const,
            canShop: true,
            canScheduleFix: true,
          },
        },
      }),
    );
  },
);

// Mock for getClientSelfie query
export const getClientSelfie = stitchfix.query(
  'getClientSelfie',
  (_req, res, ctx) => {
    return res(
      ctx.data({
        client: {
          __typename: 'Client' as const,
          id: MOCK_CLIENT_ID,
          selfieImageUrl:
            'https://res.cloudinary.com/stitch-fix/image/upload/v1753386304/client_selfies/btxrh3ax0fvjlknvvzzl.png',
        },
      }),
    );
  },
);

// Mock for getClientFullBody query
export const getClientFullBody = stitchfix.query(
  'getClientFullBody',
  (_req, res, ctx) => {
    return res(
      ctx.data({
        client: {
          __typename: 'Client' as const,
          id: MOCK_CLIENT_ID,
          photoFullBody: {
            __typename: 'ClientPhoto' as const,
            id: 'mock-full-body-photo-id',
            image: {
              __typename: 'Image' as const,
              baseUrl: 'https://res.cloudinary.com/stitch-fix/image/upload/',
              mediaPath: 'v1753386304/client_selfies/btxrh3ax0fvjlknvvzzl.png',
              altText: 'Mock full body photo',
              width: 800,
              height: 600,
            },
          },
        },
      }),
    );
  },
);

// Mock for clientSelfieUpdate mutation
export const clientSelfieUpdate = stitchfix.mutation(
  'clientSelfieUpdate',
  (_req, res, ctx) => {
    return res(
      ctx.data({
        clientSelfieUpdate: {
          __typename: 'ClientSelfieUpdatePayload' as const,
          result: {
            __typename: 'Client' as const,
            id: MOCK_CLIENT_ID,
            selfieImageUrl:
              'https://res.cloudinary.com/stitch-fix/image/upload/v1753386304/client_selfies/btxrh3ax0fvjlknvvzzl.png',
          },
        },
      }),
    );
  },
);

// Mock for clientPhotoFullBodyCreate mutation
export const clientPhotoFullBodyCreate = stitchfix.mutation(
  'clientPhotoFullBodyCreate',
  (_req, res, ctx) => {
    return res(
      ctx.data({
        clientPhotoFullBodyCreate: {
          __typename: 'ClientPhotoFullBodyCreatePayload' as const,
          result: {
            __typename: 'ClientPhotoFullBodyCreateSuccess' as const,
            clientPhoto: {
              __typename: 'ClientPhoto' as const,
              id: 'mock-full-body-photo-id',
              image: {
                __typename: 'Image' as const,
                baseUrl: 'https://res.cloudinary.com/stitch-fix/image/upload/',
                mediaPath:
                  'v1753386304/client_selfies/btxrh3ax0fvjlknvvzzl.png',
                altText: 'Mock full body photo',
                width: 800,
                height: 600,
              },
            },
          },
        },
      }),
    );
  },
);

// Mock for visionOnboardingComplete mutation
export const visionOnboardingComplete = stitchfix.mutation(
  'visionOnboardingComplete',
  (_req, res, ctx) => {
    return res(
      ctx.data({
        visionOnboardingComplete: {
          __typename: 'VisionOnboardingCompletePayload' as const,
          result: {
            __typename: 'VisionOnboardingCompleteSuccess' as const,
            isOptedInToRecurringLooks: true,
          },
        },
      }),
    );
  },
);

// Mock for Cloudinary upload
export const cloudinaryUpload = rest.post(
  'https://api.cloudinary.com/v1_1/stitch-fix/image/upload',
  (_req, res, ctx) => {
    return res(
      ctx.json({
        public_id: 'client_selfies/btxrh3ax0fvjlknvvzzl',
        secure_url:
          'https://res.cloudinary.com/stitch-fix/image/upload/v1753386304/client_selfies/btxrh3ax0fvjlknvvzzl.png',
        url: 'http://res.cloudinary.com/stitch-fix/image/upload/v1753386304/client_selfies/btxrh3ax0fvjlknvvzzl.png',
        format: 'png',
        width: 800,
        height: 600,
      }),
    );
  },
);
